<template>
  <div class="author-about__wrapper">
    <a-visibility hide :on="[$breakpoint.mobile]">
      <p class="author-about text-body">{{ about }}</p>
    </a-visibility>
    <a-visibility show :on="[$breakpoint.mobile]">
      <a-show-more
        :row-count="$options.consts.ROW_COUNT_TO_SHOW_ON_MOBILE"
        :row-height="$options.consts.ROW_HEIGHT_ON_MOBILE"
      >
        <p class="author-about text-body">{{ about }}</p>
      </a-show-more>
    </a-visibility>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'

import AShowMore from 'shared/AShowMore'

export default {
  name: 'AuthorAbout',
  components: { AShowMore },
  props: {
    about: propValidator([PROP_TYPES.STRING])
  },
  consts: {
    ROW_COUNT_TO_SHOW_ON_MOBILE: 4,
    ROW_HEIGHT_ON_MOBILE: 22
  }
}
</script>

<style lang="scss" scoped>
.author-about__wrapper {
  margin-top: 5px;

  @include mobile {
    margin-top: 20px;
  }

  .author-about {
    position: relative;
    transition: 0.3s;
    white-space: pre-wrap;
    max-width: 850px;
  }
}
</style>
